import { ProductCard } from "@aurelia/ui";
import { useProducts } from "../../features/catalog/queries";
import { useWishlist, useToggleWishlist } from "../../features/wishlist/queries";

export function RelatedProducts({ categorySlug, excludeProductId }: { categorySlug?: string; excludeProductId: string }) {
  // Fetch one extra so filtering out the current product still leaves a
  // full row when the category has enough stock.
  const { data } = useProducts({ categorySlug, pageSize: 5 }, { enabled: !!categorySlug });
  const { data: wishlist } = useWishlist();
  const toggleWishlist = useToggleWishlist();
  const wishlistedIds = new Set(wishlist?.map((p) => p.id));

  const related = (data?.items ?? []).filter((p) => p.id !== excludeProductId).slice(0, 4);

  if (related.length === 0) return null;

  return (
    <section className="mt-24 max-w-6xl mx-auto">
      <h2 className="text-display-sm mb-8">You may also like</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {related.map((p) => (
          <ProductCard
            key={p.id}
            slug={p.slug}
            name={p.name}
            imageUrl={p.images[0] ?? null}
            basePrice={p.basePrice}
            compareAtPrice={p.compareAtPrice}
            stock={p.variants.reduce((sum, v) => sum + v.stock, 0)}
            wishlisted={wishlistedIds.has(p.id)}
            onToggleWishlist={() => toggleWishlist.mutate(p.id)}
          />
        ))}
      </div>
    </section>
  );
}
